webpackJsonp([1],{

/***/ 38:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);



(function () {

    var fontSizeMatchDeviceWidth = function fontSizeMatchDeviceWidth() {
        var deviceWidth = document.documentElement.clientWidth,
            devicePixelRatio = window.devicePixelRatio || 1,
            scale = 1 / devicePixelRatio;
        console.log('deviceWidth: ', deviceWidth, 'devicePixelRatio: ', devicePixelRatio);

        document.documentElement.style.fontSize = deviceWidth * 16 / 320 * devicePixelRatio + 'px';
        console.log(document.documentElement.style.fontSize);
        document.querySelector('meta[name="viewport"]').setAttribute('content', 'width=device-width,initial-scale=' + scale + ', maximum-scale=' + scale + ', minimum-scale=' + scale + ', user-scalable=no');
    };

    (function () {
        var ua = navigator.userAgent;
        if (/android/i.test(ua) || /ipad|itouch|iphone/i.test(ua)) {
            fontSizeMatchDeviceWidth();
        } else {
            document.getElementById('container').style.maxWidth = '414px';
            document.getElementById('container').style.minWidth = '414px';
            document.documentElement.style.fontSize = '56.5px';
        }

        if ('number' === typeof window.orientation && 'object' === __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(window.onorientationchange)) {
            window.addEventListener('orientationchange', function () {
                location.reload(false);
            }, false);
        } else {}
    })();
})();

/***/ }),

/***/ 40:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(85)

var Component = __webpack_require__(26)(
  /* script */
  __webpack_require__(43),
  /* template */
  __webpack_require__(95),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 43:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_pay_vue__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_pay_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_pay_vue__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: {
    pay: __WEBPACK_IMPORTED_MODULE_0__components_pay_vue___default.a
  }
});

/***/ }),

/***/ 44:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_whatwg_fetch__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_whatwg_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_whatwg_fetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fetch_jsonp__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fetch_jsonp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_fetch_jsonp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_get_query_js__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_param_serializer_js__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_browser_js__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_pop_vue__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_pop_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_pop_vue__);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'youping',
  components: { pop: __WEBPACK_IMPORTED_MODULE_5__components_pop_vue___default.a },
  data: function data() {
    return {
      moneyBoxPop: false,
      payWayPop: false,
      price: 6,
      priceList: [1, 6, 8, 66, 88, 188],
      payChannel: 'wx',
      itemid: '',
      itemidList: {
        test: [1298, 1300, 1302, 1304, 1306, 1308],
        online: [2907, 2909, 2915, 2917, 2911, 2913]
      }
    };
  },

  methods: {
    random: function random(start, end) {
      return Math.floor(Math.random() * (end - start) + start);
    },

    isWechat: function isWechat() {
      var ua = navigator.userAgent;
      return (/MicroMessenger/i.test(ua)
      );
    },

    fetch: function (_fetch) {
      function fetch(_x, _x2, _x3) {
        return _fetch.apply(this, arguments);
      }

      fetch.toString = function () {
        return _fetch.toString();
      };

      return fetch;
    }(function (url, config, callback) {
      fetch(url, config).then(function (res) {
        return res.json();
      }).then(function (json) {
        console.log(json);
        callback(json);
      }).catch(function (err) {
        throw err;
      });
    }),

    fetchJsonp: function fetchJsonp(url, callback, isRefresh) {
      __WEBPACK_IMPORTED_MODULE_1_fetch_jsonp___default()(url).then(function (res) {
        return res.json();
      }).then(function (json) {
        callback(json, isRefresh);
      }).catch(function (err) {
        throw err;
      });
    },

    openPop: function openPop(type) {
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
      this[type] = true;
    },

    closePop: function closePop() {
      document.documentElement.style.overflow = 'auto';
      document.body.style.overflow = 'auto';
      this.moneyBoxPop = false;
      this.payWayPop = false;
    },

    selectPriceHandler: function selectPriceHandler(price, event) {
      this.price = price;
      var btnArr = document.getElementsByClassName('price_btn');
      btnArr = [].slice.call(btnArr);
      btnArr.forEach(function (item) {
        item.className = 'price_btn';
      });
      event.currentTarget.className = 'price_btn active';
    },

    pay: function pay() {
      var isTest = /test|localhost/.test(location.hostname);

      var channel_mark = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_get_query_js__["a" /* default */])('channel') || 'shengxiao';

      if (isTest) {
        this.itemid = this.itemidList.test[this.priceList.indexOf(this.price)];
      } else {
        this.itemid = this.itemidList.online[this.priceList.indexOf(this.price)];
      }

      var url = void 0;
      if (isTest) {
        url = 'http://test.shop.linghit.com/index.php?s=shop&c=pcorder&a=appreciate';
      } else {
        url = '/index.php?s=shop&c=pcorder&a=appreciate';
      }

      if (this.isWechat()) {
        this.payChannel = 'wechat';
      }

      var postConfig = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: 'goods[0][itemid]=' + this.itemid + '&pay=' + this.payChannel + '&channel_mark=' + channel_mark + '&channel=zanshang' + '&goods[0][num]=1'
      };

      fetch(url, postConfig).then(function (res) {
        return res.json();
      }).then(function (json) {
        console.log(json);

        if (json.status) {
          window.location.href = json.url;
        } else {
          mmcWapShopPayByNativeSDK({
            order_id: json.order_id,
            subject: json.subject,
            price: json.price,
            notify_url: json.notify_url,
            return_url: json.return_url
          });
        }
      }).catch(function (err) {
        throw err;
      });
    },

    payCallBack: function payCallBack(json) {
      console.log('支付返回结果', json);
      if (json) {
        mmcWapShopPayByNativeSDK({
          order_id: json.order_id,
          subject: json.subject,
          price: json.price,
          notify_url: json.notify_url,
          return_url: json.return_url
        });
      }
    }

  },
  mounted: function mounted() {},
  beforeDestroy: function beforeDestroy() {}
});

/***/ }),

/***/ 45:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'pop',
    props: {
        isPop: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        popIsPop: function popIsPop() {
            return this.isPop;
        }
    }
});

/***/ }),

/***/ 46:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_set_rem_js__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_fastclick__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_fastclick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_fastclick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_scroller__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_scroller___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_scroller__);







if ('addEventListener' in document) {
    document.addEventListener('DOMContentLoaded', function () {
        __WEBPACK_IMPORTED_MODULE_3_fastclick___default.a.attach(document.body);
    }, false);
}


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_scroller___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
    el: '#app',

    template: '<App/>',
    components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),

/***/ 47:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export browser */
var browser = {
    versions: function () {
        var u = navigator.userAgent,
            app = navigator.appVersion;
        return {
            trident: u.indexOf('Trident') > -1,
            presto: u.indexOf('Presto') > -1,
            webKit: u.indexOf('AppleWebKit') > -1,
            gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1,
            mobile: !!u.match(/AppleWebKit.*Mobile.*/),
            ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
            android: u.indexOf('Android') > -1 || u.indexOf('Adr') > -1,
            iPhone: u.indexOf('iPhone') > -1,
            iPad: u.indexOf('iPad') > -1,
            webApp: u.indexOf('Safari') == -1,
            weixin: u.indexOf('MicroMessenger') > -1,
            qq: u.match(/\sQQ/i) == " qq" };
    }(),
    language: (navigator.browserLanguage || navigator.language).toLowerCase()
};


/***/ }),

/***/ 48:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var getQueryString = function getQueryString(name, search) {
    var search = search || window.location.search.substr(1);
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
    var r = search.match(reg);
    if (r != null) return unescape(r[2]);return null;
};
/* harmony default export */ __webpack_exports__["a"] = (getQueryString);

/***/ }),

/***/ 49:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var paramSerializer = function paramSerializer(obj, ognl) {
    var query = '',
        name,
        value,
        fullSubName,
        subName,
        subValue,
        innerObj,
        i;
    for (name in obj) {
        value = obj[name];

        if (value instanceof Array) {
            for (i = 0; i < value.length; ++i) {
                subValue = value[i];
                if (subValue == 0 || subValue) {
                    fullSubName = name + "[]";
                    innerObj = {};
                    innerObj[fullSubName] = subValue;
                    query += paramSerializer(innerObj) + '&';
                }
            }
        } else if (value instanceof Object) {
            for (subName in value) {
                subValue = value[subName];
                if (subValue == 0 || subValue) {
                    if (ognl) {
                        fullSubName = name + '.' + subName;
                    } else {
                        fullSubName = name + '[' + subName + "]";
                    }
                    innerObj = {};
                    innerObj[fullSubName] = subValue;
                    query += paramSerializer(innerObj) + '&';
                }
            }
        } else if (value !== undefined && value !== null) query += encodeURIComponent(name) + '=' + encodeURIComponent(value) + '&';
    }

    return query.length ? query.substr(0, query.length - 1) : query;
};
/* unused harmony default export */ var _unused_webpack_default_export = (paramSerializer);

/***/ }),

/***/ 85:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 86:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 87:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 90:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAhCAMAAACLDYleAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA4RpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMDY3IDc5LjE1Nzc0NywgMjAxNS8wMy8zMC0yMzo0MDo0MiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDo5OWMyYWJhYS1mZWNjLTIzNGQtOTQ1Ni0yZmZhN2VhZGU1MGIiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6NjZDMjQ5MjY1NjM5MTFFNzkzMDBBRjkwQkJCMDk2NTciIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NjZDMjQ5MjU1NjM5MTFFNzkzMDBBRjkwQkJCMDk2NTciIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTUgKFdpbmRvd3MpIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6NWU4MjE3ODEtYjBkZi0wMjQzLTk5YmUtN2E4ODMzZjk0OTJmIiBzdFJlZjpkb2N1bWVudElEPSJhZG9iZTpkb2NpZDpwaG90b3Nob3A6YjU4MTAwZmYtNGI2Ni0xMWU3LTllZjAtYzU1YzI2NGYzMjI0Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+i98beAAAAGBQTFRF+72J+8WY/vTr94Yn//38+axr/NW0/dm8+JVD+rN4/urZ9nwW/eLM//n1+JI89oAd+JpL+aRd94wz/ebT/d3B+J5S/u3d+8qh+all/u/i+aBW/NKv/ejX/Ne4////9nkQiDX9igAAATVJREFUeNqUlNuWgyAMRVGkrSgieK2W8P9/WeIVrTrOeULWJpwkRAJQK2lPJFUNQICfAgPEHaLspZRD5DUiHbLbyoPeMH/jF+EA0F8jxiHkEElaNgqjlNOaUR+hcCS1ifKalKKX+UP+08s9hPDCCS1ERWGMKasfJBgcvjnnYRThsjq5aE2Q20uEOKTZI8mmnXhPtkEoMwJCw7QX5LnJiAlMA0/WRM+lznzEnRFEJ0lGPtigVqd+bRB5uUzp9N09pu70m9Kla1CnKhhubDrpISGEfjKVGOOEfUxnpAaxq0j0HKmoDFiMSAPQLY8ZvYjcVo/10ThEuqCTmfiNKenxmYsVsR0WKs5zUmMbl7mibbogNjNz0FIlvnWtms88aroNHoZU+njUbgzsjbEHfvXz4Gj3T30FGABuL3bmARe+tAAAAABJRU5ErkJggg=="

/***/ }),

/***/ 91:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAABmJLR0QAAAAAAAD5Q7t/AAAACXBIWXMAAAsSAAALEgHS3X78AAAFAElEQVRYw72WW0xUVxSGv33mAjMwCoqKFVIDaABtrD5oEyuxsfBivMQHQ9M0aRu0MRF7TZrYPtRgYt80TbQV01JrU0vTpNaaxihRqihy6QhUEDCKYFXUAnLGucKc3YczzJxhQGas9k92Zs5/9lnr32vttfcSGNGBGcF2YD2wCLDxdOADrgK/I/mSQtSxF8LgfBVQBeQ+JaeT4T5QTiE/RQS0swRByzN2PB5vUMj3YwLuAplTfiIN/8WUs+NBjpkrlCMf41wDRkO/IjRkaAjADJieWECl4C/+BJZF0QIIAgHACkWpRSy3LyfHmotDScUrvfQG+rjsdVLzqIaALwCWkBiZmAIzkoUxzn2AAjvm7mDbzG3kJ+dPauBO4A5VQ1VU3KvA7/HrdRO/CI+gDTdgNzpPt6ZzLOcYRalFcVu64b/Bpp5NtKqturX4RLgEraiAAwH4Ic2SRlthG9mW7MRiCUgkyzqX0aK2xBsJl4JGZKMF4de841HOLzy6wAc979Pl64r6cnB0gA97P6J6qNqQPUFNXg2KSdH3jxbHwImKE0k9cvW11XI8ZrXOkvyMfKlzRRRf3lcu+QXJJaRf80e9q+ivkFxA4pxyqEq4pIJQNqMsJkbbZ20nNyuXLRlbo/iNaRvJy8pjy9wtWIUVgP6RfprdzcwQM/SI+nS7ofxMOATNqGg40MD5gpOl9qUJ537v3b10e7uRQmJRLCQpVm6O9HLV00mHu11PRxITlanLbDxUxlYSL2pdtey6vYt8az4b0jewctpKHCZH1JwWdwuH7h/iwN0DelSSDREAoBGVRiTnkaeGT8l48fWDb+Rzznny9PDpuOafHT4rHZdSJeeRNCFpRNKICg2oNCA5iyzvLY/LWL2rXmY5s2WP72aY80hvzLwRORr13O5pl6JO6Bu0AUkDKtSjUq9HIOlisvQEPVMKWNu5Vh59cDT8XKfWSXONWa7rXBfm7gfuSdtFm5zZlCG9wYi43X/vltToVUe9sQrM4Hf72Ny1+bF5v+K5gk3YKc0oDXM+zceob5SBkYEwF5QaXp+XgcA/SMPOezfzPax2q74fJChRZWGHE7dP8Na1twlogQkF1Kl1ZFnmRXFrpq/hVvEtzi06F+YyrZn0v9zP8PJhbEqksUo1pbA4ZbFeGVK/jCJ1KgAbfNtVhUWYqcyrjBFgN6WQrCTF8FnWrBhujmXOhIuwC3t40dER0EK/JiiwFQDQ7Grm8O3DtLnbUIMq2ZYs1KAroXIdjw53R7ivMMdcGBooyQpL7C+yp28PO7t36uGywzTrNKZJBwExwv6c/U/k/PjgcQYfDoZvTEEtKoLI6SFBURSQoHm1SKMRNETID1sXvMPBhV8lLOD5i/Ppc/WO9dsuJeZ8BjRNQwtq+qllCvFKSIhVj0bltYN81rMrbseDI4O8enkNfUO9katagok3+SRkNhqTNZ1jYhT4404tnb5OClIKmG2d/VgBpR2vcfL6SUgz2IGA4IyhI0oEIpQSN5AMxRklrEpfRa4tB5vJxtDIEE3DTQhNsC9/H0f6j1DWXAbRV8UjwRm6gQUJCzAKGQX8IUEmgzgNCML8OfNZ4VhB9b3qSGcd/ryGz4GPn1jARCkyihMGcbFt2nXBaaYDD5+agMSwXqGYYSSvT9axPMNRTTG/KQCU8AOw7X9c+XeUUArji+0US4BPgVeYqDT/GyTQDnxBCT+Okf8CQNQw0DUcIK8AAAAASUVORK5CYII="

/***/ }),

/***/ 92:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo.04ef6bd.png";

/***/ }),

/***/ 93:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(86)

var Component = __webpack_require__(26)(
  /* script */
  __webpack_require__(44),
  /* template */
  __webpack_require__(96),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 94:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(87)

var Component = __webpack_require__(26)(
  /* script */
  __webpack_require__(45),
  /* template */
  __webpack_require__(97),
  /* scopeId */
  "data-v-7b522a38",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 95:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('pay')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 96:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "pay"
  }, [_c('div', {
    staticClass: "pay_title"
  }, [_vm._v("您的赞赏，是对我创作的最大鼓励")]), _vm._v(" "), _c('div', {
    staticClass: "pay_money"
  }, [_c('button', {
    staticClass: "price_btn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.selectPriceHandler(1, $event)
      }
    }
  }, [_c('span', {
    staticClass: "price"
  }, [_vm._v("1")]), _c('span', {
    staticClass: "unit"
  }, [_vm._v("元")])]), _vm._v(" "), _c('button', {
    staticClass: "price_btn active",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.selectPriceHandler(6, $event)
      }
    }
  }, [_c('span', {
    staticClass: "price"
  }, [_vm._v("6")]), _c('span', {
    staticClass: "unit"
  }, [_vm._v("元")])]), _vm._v(" "), _c('button', {
    staticClass: "price_btn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.selectPriceHandler(8, $event)
      }
    }
  }, [_c('span', {
    staticClass: "price"
  }, [_vm._v("8")]), _c('span', {
    staticClass: "unit"
  }, [_vm._v("元")])])]), _vm._v(" "), _c('div', {
    staticClass: "pay_money"
  }, [_c('button', {
    staticClass: "price_btn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.selectPriceHandler(66, $event)
      }
    }
  }, [_c('span', {
    staticClass: "price"
  }, [_vm._v("66")]), _c('span', {
    staticClass: "unit"
  }, [_vm._v("元")])]), _vm._v(" "), _c('button', {
    staticClass: "price_btn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.selectPriceHandler(88, $event)
      }
    }
  }, [_c('span', {
    staticClass: "price"
  }, [_vm._v("88")]), _c('span', {
    staticClass: "unit"
  }, [_vm._v("元")])]), _vm._v(" "), _c('button', {
    staticClass: "price_btn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.selectPriceHandler(188, $event)
      }
    }
  }, [_c('span', {
    staticClass: "price"
  }, [_vm._v("188")]), _c('span', {
    staticClass: "unit"
  }, [_vm._v("元")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticClass: "other_btn"
  }, [_c('a', {
    staticClass: "btn",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.openPop('moneyBoxPop')
      }
    }
  }, [_vm._v("其它金额")])]), _vm._v(" "), _c('div', {
    staticClass: "pay_btn"
  }, [_c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.openPop('payWayPop')
      }
    }
  }, [_vm._v("赞赏")])]), _vm._v(" "), _c('pop', {
    attrs: {
      "isPop": _vm.moneyBoxPop
    }
  }, [_c('div', {
    staticClass: "other_money"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("赞赏金额")]), _vm._v(" "), _c('div', {
    staticClass: "input_box"
  }, [_c('span', {
    staticClass: "tip"
  }, [_vm._v("金额")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.price),
      expression: "price"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入1-999元"
    },
    domProps: {
      "value": (_vm.price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.price = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pay_btn"
  }, [_c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.openPop('payWayPop')
      }
    }
  }, [_vm._v("赞赏")])])]), _vm._v(" "), _c('div', {
    staticClass: "close_btn",
    on: {
      "click": _vm.closePop
    }
  })]), _vm._v(" "), _c('pop', {
    attrs: {
      "isPop": _vm.payWayPop
    }
  }, [_c('div', {
    staticClass: "pay_way"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("支付方式")]), _vm._v(" "), _c('div', {
    staticClass: "pay_cont"
  }, [_c('div', {
    staticClass: "pay_item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.payChannel),
      expression: "payChannel"
    }],
    attrs: {
      "type": "radio",
      "name": "payway",
      "id": "wechat",
      "value": "wx",
      "checked": ""
    },
    domProps: {
      "checked": _vm._q(_vm.payChannel, "wx")
    },
    on: {
      "__c": function($event) {
        _vm.payChannel = "wx"
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "filling_wrap",
    attrs: {
      "for": "wechat"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "icon_wechat",
    attrs: {
      "src": __webpack_require__(91)
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "way"
  }, [_vm._v("微信支付")]), _vm._v(" "), _c('span', {
    staticClass: "tip"
  }, [_vm._v("推荐微信用户使用")])]), _vm._v(" "), _c('div', {
    staticClass: "pay_item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.payChannel),
      expression: "payChannel"
    }],
    attrs: {
      "type": "radio",
      "name": "payway",
      "id": "alipay",
      "value": "alipay"
    },
    domProps: {
      "checked": _vm._q(_vm.payChannel, "alipay")
    },
    on: {
      "__c": function($event) {
        _vm.payChannel = "alipay"
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "filling_wrap",
    attrs: {
      "for": "alipay"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "icon_wechat",
    attrs: {
      "src": __webpack_require__(90)
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "way"
  }, [_vm._v("支付宝支付")]), _vm._v(" "), _c('span', {
    staticClass: "tip"
  }, [_vm._v("支付方便快捷")])])]), _vm._v(" "), _c('div', {
    staticClass: "pay_submit"
  }, [_c('button', {
    staticClass: "btn",
    on: {
      "click": _vm.pay
    }
  }, [_vm._v(_vm._s(_vm.price) + "元")])])]), _vm._v(" "), _c('div', {
    staticClass: "close_btn",
    on: {
      "click": _vm.closePop
    }
  })])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "artical"
  }, [_c('img', {
    staticClass: "artical_img",
    attrs: {
      "src": __webpack_require__(92)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "artical_cont"
  }, [_vm._v("“命运”包括两个含义，一是命，即由命主的八字所组成的一定的排列组合，由它所反映的吉或凶，福或祸。二是运，即人一生所走过的每个阶段。“命”和“运”的组合构成了千姿百态的人生“命运”。")])])
}]}

/***/ }),

/***/ 97:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.popIsPop) ? _c('div', {
    staticClass: "pop"
  }, [_c('div', {
    staticClass: "pop_mask"
  }), _vm._v(" "), _c('div', {
    staticClass: "pop_panel"
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "body"
  }, [_vm._t("default")], 2)])])]) : _vm._e()
},staticRenderFns: []}

/***/ })

},[46]);


// WEBPACK FOOTER //
// static/js/app.b9d86ab05b4c85309c7d.js